module.exports = __webpack_public_path__ + "img/user-card-green-icon.8791e03a.svg";